import React from 'react';

const BpLogo: React.FC = () => (
	<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.8871 33.546C26.4187 33.546 33.3348 26.5861 33.3348 18.0005C33.3348 9.41502 26.4187 2.45508 17.8871 2.45508C9.35562 2.45508 2.43945 9.41502 2.43945 18.0005C2.43945 26.5861 9.35562 33.546 17.8871 33.546Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.0228 13.2371L9.75684 17.7786V13.5415L25.0228 9V13.2371Z"
			fill="#EC6A5A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.0228 21.4189L9.75684 25.9603V21.7233L25.0228 17.1816V21.4189Z"
			fill="#007270"
		/>
		<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="36">
			<path d="M0 0H35.3525V36H0V0Z" fill="white" />
		</mask>
		<g mask="url(#mask0)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.5644 3.6586C9.86024 3.6586 3.59281 10.0411 3.59281 17.8863C3.59281 25.7315 9.86024 32.1139 17.5644 32.1139C25.2688 32.1139 31.5363 25.7315 31.5363 17.8863C31.5363 10.0411 25.2688 3.6586 17.5644 3.6586ZM17.5644 35.7725C7.87907 35.7725 0 27.7489 0 17.8863C0 8.0239 7.87907 0 17.5644 0C27.2494 0 35.1291 8.0239 35.1291 17.8863C35.1291 27.7489 27.2494 35.7725 17.5644 35.7725Z"
				fill="#00AECA"
			/>
		</g>
	</svg>
);

export default BpLogo;
